import { fg } from '@atlassian/jira-feature-gating';

const isFetchFieldOperationsInEditIconEnabled = {
	get(): boolean {
		return fg('issue_view_field_config_edit') && !fg('dfo_remove_field_fragments');
	},
};

export default isFetchFieldOperationsInEditIconEnabled;
